import './typography.css';
import { css } from 'styled-components';

// Mantém as cores do ThemeProvider existente. Fallbacks só atuam na ausência delas.
export const surface = ({ theme = {} }) => `var(--ui-surface, ${theme.bg || '#ffffff'})`;
export const mutedSurface = ({ theme = {} }) => `var(--ui-muted-surface, ${theme.bg3 || '#f1f5f9'})`;
export const ink = ({ theme = {} }) => `var(--ui-ink, ${theme.text || '#243247'})`;
export const border = ({ theme = {} }) => theme.uiBorder || 'rgba(128, 145, 167, .28)';
export const accent = ({ theme = {} }) => theme.primary || '#315cbe';
export const focus = css`
  &:focus-visible {
    outline: 2px solid ${accent};
    outline-offset: 3px;
  }
`;
export const panel = css`
  background: ${surface};
  color: ${ink};
  border: 1px solid ${border};
  border-radius: 12px;
  box-shadow: 0 3px 16px rgba(15, 23, 42, .04);
`;
export const label = css`
  display: block;
  padding: 0;
  margin-bottom: 6px;
  border: 0;
  border-radius: 0;
  background: transparent;
  color: ${ink};
  font-size: 12px;
  font-weight: 600;
  line-height: 1.5;
  white-space: normal;
  text-align: left;
`;
export const field = css`
  min-height: 40px;
  border: 1px solid ${border};
  border-radius: 8px;
  padding: 9px 12px;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.5;
  color: #243247;
  background-color: #f8fafc;
  &:focus {
    color: #243247;
    background-color: #ffffff;
    border-color: ${accent};
    box-shadow: 0 0 0 3px rgba(72, 110, 180, .16);
  }
  &:disabled, &[readonly] {
    background-color: #edf1f5;
    color: #243247;
    opacity: .8;
  }
  &[aria-invalid='true'], &.is-invalid { border-color: #c93d50; }
  @media (max-width: 576px) { font-size: 16px; }
`;
export const selectControl = css`
  min-width: 0;
  font-family: inherit;
  [class*='control'] {
    min-height: 40px;
    border-radius: 8px;
    border-color: ${border};
    background-color: #f8fafc;
    font-size: 14px;
  }
  [class*='singleValue'], [class*='input'] { color: #243247; }
  &:focus-within [class*='control'] {
    border-color: ${accent};
    box-shadow: 0 0 0 3px rgba(72, 110, 180, .16);
  }
  @media (max-width: 576px) { [class*='control'] { font-size: 16px; } }
`;
export const button = css`
  border-radius: 8px;
  font-weight: 600;
  line-height: 1.5;
  ${focus}
`;

// Color-mix mantém contraste de zebra em temas claros e escuros.
export const zebra = css`
  background-color: ${mutedSurface};
  background-color: color-mix(in srgb, ${surface} 91%, ${ink} 9%);
`;
export const actionButton = css`
  ${button}
  --action-color: #315cbe;
  &.btn-info, &.btn-outline-info { --action-color: #087b92; }
  &.btn-success, &.btn-outline-success { --action-color: #237753; }
  &.btn-danger, &.btn-outline-danger { --action-color: #bb354b; }
  &.btn-warning, &.btn-outline-warning { --action-color: #956009; }
  &.btn-secondary, &.btn-outline-secondary { --action-color: #57657a; }
  &.btn-dark, &.btn-outline-dark { --action-color: #46566b; }
  &.btn-light, &.btn-outline-light { --action-color: #57657a; }
  /* && prevalece sobre as variantes do Bootstrap, sem depender da versão 5. */
  && {
    display: inline-flex; align-items: center; justify-content: center; gap: 7px;
    font-family: var(--ui-font); font-size: 12px; font-weight: 600;
    color: var(--action-color); background: #fff;
    border: 1px solid var(--action-color); border-radius: 9px;
    box-shadow: 0 1px 2px rgba(15,23,42,.05);
    transition: background-color .15s ease, color .15s ease, box-shadow .15s ease;
  }
  &&:hover:not(:disabled) {
    background: var(--action-color); color: #fff;
    box-shadow: 0 3px 8px rgba(15,23,42,.12);
  }
  &&:active:not(:disabled) { background: var(--action-color); color: #fff; box-shadow: none; }
  &&:disabled, &&.disabled { opacity: .45; box-shadow: none; }
  svg { flex-shrink: 0; width: 17px; height: 17px; }
  @media (prefers-reduced-motion: reduce) { && { transition: none; } }
`;

export const cardSurface = css`
  --ui-surface: #ffffff;
  --ui-muted-surface: #f4f6fa;
  --ui-ink: #243247;
  background: #ffffff;
  color: #243247;
`;
